import { render, staticRenderFns } from "./RealEstate.vue?vue&type=template&id=61a6d832&scoped=true&"
import script from "./RealEstate.vue?vue&type=script&lang=js&"
export * from "./RealEstate.vue?vue&type=script&lang=js&"
import style0 from "./RealEstate.vue?vue&type=style&index=0&id=61a6d832&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a6d832",
  null
  
)

export default component.exports